import {useState, useEffect} from 'react'

export const useElementSizeObserver = (ref, options = {}) => {
    const {minWidth = 0, minHeight = 0} = options
    const [size, setSize] = useState({
        width: minWidth,
        height: minHeight,
    })

    useEffect(() => {
        const element = ref?.current
        if (!element) return

        const resizeObserver = new ResizeObserver((entries) => {
            const entry = entries[0]
            if (!entry?.contentRect) return

            const width = Math.max(minWidth, entry.contentRect.width)
            const height = Math.max(minHeight, entry.contentRect.height)

            setSize((prev) => {
                if (prev.width === width && prev.height === height) return prev
                return {width, height}
            })
        })

        resizeObserver.observe(element)
        return () => {
            resizeObserver.disconnect()
        }
    }, [ref, minWidth, minHeight])

    return size
}
